import type { ReactNode } from 'react';

import { Card, CardAction, CardContent, CardHeader } from '../../../ui/card';

export function OverviewCard(props: {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <Card>
      <CardHeader>
        <h2 className="text-title-sm">{props.title}</h2>
        {props.aside !== undefined && <CardAction>{props.aside}</CardAction>}
      </CardHeader>
      <CardContent className="flex flex-col gap-3">{props.children}</CardContent>
    </Card>
  );
}
